import { render, staticRenderFns } from "./FactorsWithoutManageAccess.vue?vue&type=template&id=13338e80"
import script from "./FactorsWithoutManageAccess.vue?vue&type=script&lang=js"
export * from "./FactorsWithoutManageAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports